import styled from 'styled-components';

import { Container as PassengerCountInputContainer } from 'components/shared/PassengerCountInput';

import { colours } from 'themes/default';

export const Title = styled.p`
  font-weight: bold;
`;

export const Container = styled.div``;

export const PassengerCountGroup = styled.div`
  display: flex;

  ${/* sc-selector */ PassengerCountInputContainer}:not(:last-child) {
    margin-right: 24px;
  }
`;

export const ErrorMessageContainer = styled.div`
  color: ${colours.Messaging.ErrorRed};
`;
